// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "chartkick/highcharts"

import $ from 'jquery';
import select2 from 'select2';

// Make jQuery available globally if other scripts rely on it
window.jQuery = $;
window.$ = $;

// Initialize select2 on the jQuery object
select2($);

import Datepicker from "vanillajs-datepicker/Datepicker"
window.Datepicker = Datepicker;
